import { useCallback, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { logger } from "@/lib/logger";
import { useAuth } from "@/lib/auth";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { FileText, LogOut, Plus, RefreshCw } from "lucide-react";
import Header from "@/components/Header";
import { InscricaoCard } from "./cidadao/InscricaoCard";

export default function AreaCidadaoPage() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [items, setItems] = useState([]);
  const [editTel, setEditTel] = useState({});

  // Cidadão Google sem CPF ainda precisa vincular antes de ver inscrições
  useEffect(() => {
    if (user && user.role === "cidadao" && !(user.cpf || "").trim()) {
      nav("/vincular-cpf", { replace: true });
    }
  }, [user, nav]);

  const load = useCallback(async () => {
    try { const r = await api.get("/inscricoes"); setItems(r.data.items); }
    catch (e) { logger.error("Falha ao listar inscrições", e); }
  }, []);
  useEffect(() => { load(); }, [load]);

  const onDocChange = (inscricaoId, newDoc) => {
    setItems((prev) => prev.map((it) => it.id === inscricaoId
      ? { ...it, documentos: [...(it.documentos || []).filter((d) => d.tipo !== newDoc.tipo), newDoc] }
      : it,
    ));
  };

  return (
    <div className="min-h-screen bg-[#F4F6F9]">
      <Header />
      <div className="max-w-5xl mx-auto px-4 py-8" data-testid="area-cidadao">
        <div className="flex items-center justify-between flex-wrap gap-3 mb-6">
          <div>
            <h1 className="text-3xl font-black text-[#083CA6]">Olá, {user?.nome?.split(" ")[0]}</h1>
            <p className="text-sm text-slate-600">Acompanhe suas inscrições, envie documentos pendentes e veja o histórico de atualizações.</p>
          </div>
          <div className="flex gap-2">
            <Link to="/inscricao"><Button className="bg-[#00883A] hover:bg-[#007030]" data-testid="btn-nova-inscricao"><Plus className="w-4 h-4 mr-2" />Nova Inscrição</Button></Link>
            <Button variant="outline" onClick={load} data-testid="btn-reload-area"><RefreshCw className="w-4 h-4" /></Button>
          </div>
        </div>

        {items.length === 0 ? (
          <Card>
            <CardContent className="p-10 text-center">
              <FileText className="w-12 h-12 mx-auto text-slate-300 mb-3" />
              <h3 className="font-bold mb-1">Nenhuma inscrição encontrada</h3>
              <p className="text-sm text-slate-500 mb-4">Comece sua pré-inscrição para o programa MCMV 2026.</p>
              <Link to="/inscricao"><Button className="bg-[#083CA6] hover:bg-[#062f85]">Fazer Inscrição</Button></Link>
            </CardContent>
          </Card>
        ) : (
          <div className="space-y-4">
            {items.map((it) => (
              <InscricaoCard
                key={it.id}
                inscricao={it}
                editTel={editTel[it.id]}
                setEditTel={(v) => setEditTel((p) => ({ ...p, [it.id]: v }))}
                onReload={load}
                onDocChange={onDocChange}
              />
            ))}
          </div>
        )}

        <div className="mt-8 text-center">
          <Button variant="ghost" onClick={async () => { await logout(); window.location.href = "/"; }} data-testid="btn-logout-cidadao">
            <LogOut className="w-4 h-4 mr-2" />Sair
          </Button>
        </div>
      </div>
    </div>
  );
}
